<template>
<keep-alive>
  <router-view />
</keep-alive>

</template>
<script lang="ts">
import { onBeforeMount } from "vue";
import {
  useRouter,
  useRoute,
  LocationQueryValue,
  onBeforeRouteLeave,
} from "vue-router";
export default {
  name: "appMain",
  setup() {
    const router = useRouter();
    onBeforeMount(() => {
      //跳转路由页面滚动到顶部
      router.afterEach((to, from, next) => {
        window.scrollTo(0, 0);
      });
      // 手机端访问跳转到旧版手机
      // if(navigator.userAgent.match(/mobile/i)){
      //   // location.href = location.origin + '/mobile/index'
      //   location.href = 'https://liberal-edu.cn/mobile/index'
      // }

      
    });

  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
::-webkit-scrollbar {
  width: 8px;
  height: 5px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  /* -webkit-box-shadow:inset006pxrgba(0,0,0,0.3); */
  border-radius: 1px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #82848f;
  /* -webkit-box-shadow:inset006pxrgba(0,0,0,0.5); */
}
::-webkit-scrollbar-thumb:window-inactive {
  background: #82848f;
}
</style>
